module.exports = __webpack_public_path__ + "static/media/hotelgloriaoglas02.c91b2d46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Glorija/hotelgloriaoglas02.jpg
// module id = 376
// module chunks = 0